<template>
  <div class="home-head">
    <div
      id="searchBar"
      :class="[searchBarFixed == true ? 'isfixed' : '']"
    >
      <div class="header-cont maxW clear">
        <!-- logo -->
        <div
          class="logo fl"
          @click="pageHome"
        >
          <img
            v-if="logo_url"
            :src="BASE_URL + logo_url"
            alt="logo"
          />
        </div>
        <div class="login-info fr">
          <!-- 未登录 -->
          <div
            class="header-btns"
            v-if="userId == 0"
          >
            <img
              src="../../../assets/images/head@2x.png"
              alt=""
            >
            <el-button
              type="text"
              @click="goToLogin"
            >{{ $t('homepage.pleaseLogin') }}</el-button>
            <!--  <i class="cut">|</i>
                        <router-link to="/register">
                            <el-button type="text">{{$t('homepage.register')}}</el-button>
                        </router-link> -->
          </div>
          <!--已登录 hover用户头像弹框 -->
          <el-popover
            v-else
            class="home-popover"
            placement="bottom"
            width="260"
            trigger="hover"
          >
            <div class="userinfoH">
              <div class="userinfoH_1">
                <a
                  class="changeIdentity"
                  href="javascript:;"
                  v-if="role.length > 1"
                  @click="dialogVisible = true"
                  :title="$t('homepage.changeRole')"
                >
                  <i class="ipng icon_qiehuanshenfen"></i>
                  {{ $t('homepage.changeRole') }}
                </a>
                <a
                  class="managerole"
                  href="javascript:;"
                  v-if="managerole == true"
                  @click="goToMedule(1)"
                  :title="$t('homepage.manage')"
                >
                  <i class="ipng icon_guanlizhongxin"></i>
                  {{ $t('homepage.manage') }}
                </a>
                <!-- <a
                                    class="messagerole"
                                    href="javascript:;"
                                    v-if="messageFlag == true"
                                    @click="goToMedule(2)"
                                >
                                    <el-badge
                                        :hidden="messageCount == 0"
                                        :value="messageCount"
                                        :max="99"
                                        class="message-count"
                                    >
                                        <i class="ipng icon_youjian"></i>
                                        <i>我的消息</i>
                                    </el-badge>
                                </a> -->
                <!-- <template> -->
                <!-- <a
                                        class="personalfile"
                                        href="javascript:;"
                                        v-if="role.indexOf(4) > -1"
                                        @click="goToMedule(4)"
                                    >
                                        <i class="personalfile-icon"></i>
                                        个人档案
                                    </a> -->
                <!-- </template> -->
                <router-link
                  v-if="!pathOption.notSetting"
                  class="home-settings"
                  to="/setting"
                >
                  <i class="ipng icon_shezhi"></i>
                  {{ $t('homepage.settings') }}
                </router-link>
              </div>
              <!-- <a
                                class="personalrole"
                                href="javascript:;"
                                v-if="personalFlag == true"
                                @click="goToMedule(3)"
                            >
                                <i class="ipng icon_gerenzhongxin"></i>
                                个人中心
                            </a> -->
              <p
                class="safe-exit"
                @click="loginOut"
              >{{ $t('homepage.loginOut') }}</p>
            </div>
            <!-- 用户头像、名字、职称 -->
            <div
              class="user-info"
              slot="reference"
            >
              <a
                href="javascript:;"
                class="user-info-a"
              >
                <div class="avatar-img">
                  <img :src="userInfo.avatar_path" />
                  <!-- <img v-else :src="BASE_URL + userInfo.avatar_path" /> -->
                </div>
                <div class="avatar-text">
                  <i
                    class="userName"
                    :title="userInfo.name"
                  >{{ userInfo.name }}</i>
                  <em
                    class="roleName"
                    :title="userInfo.check_role_name"
                  >{{ userInfo.check_role_name }}</em>
                </div>
              </a>
            </div>
          </el-popover>
        </div>
        <!-- 头部搜索框 -->
        <div class="head-search fr">
          <template>
            <el-select
              v-model="selectVal"
              :placeholder="$t('global.choose')"
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>

          <i class="gery-line"></i>
          <el-input
            :placeholder="$t('global.keyword')"
            v-model="keyWord"
            class="input-with-select"
            clearable
            @keyup.enter.native="searchContent"
          >
            <el-button
              type="primary"
              slot="append"
              @click="searchContent"
            >
              <span>{{ $t('global.search') }}</span>
            </el-button>
          </el-input>
        </div>
      </div>
    </div>
    <!-- 头部菜单栏 -->
    <div
      class="i_nav maxW"
      v-show="searchBarFixed == false"
    >
      <el-menu
        class="head-menu"
        :default-active="activeInx"
        mode="horizontal"
        @select="selectMenuTab"
      >
        <el-menu-item
          v-for="(item, index) of headMenuData"
          :key="index"
          :index="index + ''"
        >
          <!-- 默认导航模块 -->
          <template v-if="item.is_default == 1">
            <router-link
              v-if="item.is_new_form == 0"
              :to="item.url"
            >{{ item.name }}</router-link>
            <router-link
              v-else
              :to="item.url"
              target="_blank"
              rel="noopener noreferrer"
            >{{ item.name }}</router-link>
          </template>
          <!-- 自定义导航模块 -->
          <template v-else>
            <a
              v-if="item.is_new_form == 0"
              @click="goHref(item.url)"
            >{{ item.name }}</a>
            <a
              v-else
              :href="item.url"
              target="_blank"
              rel="noopener noreferrer"
            >{{ item.name }}</a>
          </template>
          <!-- 二级菜单 -->
          <div
            class="menu-hover-box"
            v-if="item.children.length != 0"
            :style="{ left: -index * 102 + 'px' }"
          >
            <ul class="clear">
              <li
                v-for="(item1, index1) of item.children"
                :key="index1"
              >
                <!-- 默认导航模块 -->
                <template v-if="item1.is_default == 1">
                  <router-link
                    v-if="item1.is_new_form == 0"
                    :to="item1.url"
                  >{{ item1.name }}</router-link>
                  <router-link
                    v-else
                    :to="item1.url"
                    target="_blank"
                    rel="noopener noreferrer"
                  >{{ item1.name }}
                  </router-link>
                </template>
                <!-- 自定义导航模块 -->
                <template v-else>
                  <a
                    v-if="item1.is_new_form == 0"
                    @click="goHref(item1.url)"
                  >{{ item1.name }}</a>
                  <a
                    v-else
                    :href="item1.url"
                    target="_blank"
                    rel="noopener noreferrer"
                  >{{ item1.name }}</a>
                </template>
              </li>
            </ul>
          </div>
        </el-menu-item>
      </el-menu>
    </div>
    <!-- 设置语言版本 -->
    <div class="lang-set">
      <el-dropdown @command="setLang">
        <el-button type="primary">
          {{ langTxt }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="lang of langData"
            :key="lang.value"
            :command="lang.value"
          >{{ lang.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 切换身份弹窗 -->
    <el-dialog
      :title="$t('homepage.changeRole')"
      class="common-dialog identity-dialog"
      width="400px"
      :visible.sync="dialogVisible"
    >
      <div>
        <ul class="role-ul">
          <li
            v-for="(item, index) in userInfo.role"
            :key="index"
            @click="checkRole = item"
          >
            <span class="role-icon">
              <i
                v-if="item == 6"
                class="ipng icon_guanliyuan"
              ></i>
              <i
                v-else-if="item == 5"
                class="ipng icon_guanliyuan"
              ></i>
              <i
                v-else
                class="ipng icon_guanliyuan"
              ></i>
              <i
                v-show="checkRole == item"
                class="ipng Select01"
              ></i>
            </span>
            <span class="rolename">{{
							userInfo.rolename[index]
						}}</span>
          </li>
        </ul>
      </div>
      <div class="foot-btns">
        <el-button @click="dialogVisible = false">{{ $t('global.cancel') }}</el-button>
        <el-button
          type="primary"
          @click="changeRole"
        >{{ $t('global.sure') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fail } from "assert";
export default {
  props: {
    pathOption: {
      personal: "", //个人中心跳转路径
      manage: "", //后台跳转路径
      notSetting: "", // 不显示账号设置
    },
  },
  data() {
    return {
      jumpPage: "",
      // 学校多级参数，跳前台模块或者跳个人中心的时候带上
      CheckSchoolAppCode:
        this.$route.query.CheckSchoolAppCode == undefined
          ? "00000000000000000000000000000000"
          : this.$route.query.CheckSchoolAppCode,
      logo_url: "", //logo地址
      activeInx: "0", //菜单栏高亮默认选中第一个
      headMenuData: [], //菜单栏数据
      activeArr: [], // 存放headMenuData的url属性
      keyWord: "", //搜索输入的关键字
      selectVal: "1", //搜索框左侧下拉标题选中的索引
      searchBarFixed: false, //是否固定在顶部的判断
      loginData: {}, //登录用户的所有信息
      userId: 0, //用户id
      // userInfo: {}, //用户身份信息
      role: [], //身份id数组
      dialogVisible: false, //切换身份弹窗
      checkRole: null, //当前的身份
      isTeacher: 0, //是否是老师
      teacherAuthority: 0, //教师权限（一般情况下管理员拥有教师权限）
      managerole: false, //后台权限
      personalFlag: false, //个人中心权限
      messageFlag: false, //我的消息
      messageCount: 0, //我的消息数量
      isVistor: 0, //是否是游客
      casFlag: false, //是否是单点登录
      login_out: "",
      scrollHandler: null, //页面滚动触发器
      loginOutHost: "", //单点登录退出的地址
      langData: [
        {
          label: "中 文",
          value: "zh-cn",
        },
        {
          label: "中文繁体",
          value: "zh-hk",
        },
        {
          label: "英 文",
          value: "en-us",
        },
      ],
    };
  },
  created() {
    this.getLogo();
    this.getHeadMenu();
    this.checkCas();
    this.getActiveIndex();
  },
  mounted() {
    this.$nextTick(function () {
      this.messageUnread();
      this.checkLogin();
    });
    this.loginOutHost = sessionStorage.getItem("host_addr");
    //页面下滚，顶部导航栏吸顶。此处通过原生js监听scroll的高度如果超过导航条长度103px就出发吸顶，
    //但是频繁触发scoll resize这类事件都是很耗费性能的，此处调用debounce函数对scroll事件进行延迟处理，设定时间仅调用最后一次，
    //这样页解决了不断的上下滚动页面时，页面出现上下抖动的问题。
    this.scrollHandler = this.debounce(() => {
      this.handleScroll();
    }, 100);
    // window.addEventListener("scroll", this.scrollHandler);

    // 根据地址栏是有关键字参数的，判断是否在页面刷新时，把之前的数据重新展示
    if (this.$route.query.keyword == undefined) {
      this.selectVal = "1";
      this.keyWord = "";
      sessionStorage.setItem("selectVal", "1");
    } else {
      this.selectVal = sessionStorage.getItem("selectVal");
      this.keyWord = this.$route.query.keyword;
    }
    // 页面刷新，判断菜单选中高亮效果
    // this.changeRoute();
  },
  watch: {
    // 路由变化的时候，也切换菜单选中高亮效果
    $route(to, from) {
      if (to != from) {
        // this.changeRoute();
      }
    },
  },
  computed: {
    isTencentCloud() {
      return sessionStorage.getItem("tencentCloud") == 1; // 是否为腾讯云平台
    },
    langTxt() {
      let item = this.langData.filter((x) => x.value === this.$i18n.locale);
      return item[0].label;
    },
    userInfo() {
      //此处修改方便账号设置修改信息后，页面头部信息也同步修改
      let userInfo = this.$store.getters.userInfo;
      if (userInfo.first_login === 1 && this.isTencentCloud) {
        this.loginOut();
      }
      if (!userInfo.avatar_path) return userInfo;
      if (
        userInfo.avatar_path.includes("/static/default/user_preview-1.png") ||
        userInfo.avatar_path.includes("/public/picture")
      ) {
        if (!userInfo.avatar_path.includes("http")) {
          userInfo.avatar_path = this.BASE_URL + userInfo.avatar_path;
        }
      }
      return userInfo;
      // const data = JSON.parse(sessionStorage.getItem("user_info_str"));
      // console.log('xxxx')
      // return data ? data : {};
    },
    selectOptions() {
      return [
        //搜索框左侧下拉标题数组
        {
          value: "1",
          label: this.$t("homepage.resource"),
        },
        {
          value: "2",
          label: this.$t("homepage.album"),
        },
        {
          value: "3",
          label: this.$t("modules.live"),
        },
        {
          value: "4",
          label: this.$t("modules.video"),
        },
      ];
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandler); //移除页面滚动事件的监听
  },
  methods: {
    getActiveIndex() {
      this.activeInx = is_empty(sessionStorage.getItem("activeInx"))
        ? "0"
        : sessionStorage.getItem("activeInx");
    },
    // 根据路由地址设置菜单高亮
    // changeRoute() {
    // 	// console.log('路由名称',this.$route.meta.activeName)
    // 	// let active = this.$route.meta.activeInx;
    // 	let active = this.$route.meta.activeName;
    // 	// console.log(active)
    // 	let arr = this.activeArr;
    // 	// // console.log('arr', arr)
    // 	// arr.forEach(element => {
    // 	// 	// console.log(element)
    // 	// });
    // 	// for (let i = 0; i < arr.length; i++) {
    // 	// 	if (active == arr[i]) {
    // 	// 		active = i;
    // 	// 		break;
    // 	// 	} else if (arr[i].includes(active)) {
    // 	// 		active = i;
    // 	// 		break;
    // 	// 	}
    // 	// }
    // 	// this.activeInx = '' + active;
    // 	// sessionStorage.setItem("selectVal", active);
    // },
    // 判断当前是否单点登录跳
    checkCas() {
      let success = (res) => {
        if (res.data == "yes") {
          this.casFlag = true;
        } else {
          this.casFlag = false;
        }
      };
      this.$ajax.get("api/login/get_use_single_login", {
        params: {},
        func: {
          success: success,
        },
      });
    },
    // 跳转到登录页
    goToLogin() {
      // 待完善，如果商学院不需要登录的话，这样做会无法获取场景模式
      this.$router.push("/user-login");
    },
    //页面向下滚动的时候，搜索栏吸顶事件
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // var offsetTop = document.querySelector("#searchBar").offsetTop;
      if (scrollTop > 103) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    },
    //延迟处理
    debounce(func, wait, immediate) {
      let timeout, args, context, timestamp, result;
      const later = function () {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp;

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
          timeout = setTimeout(later, wait - last);
        } else {
          timeout = null;
          // 如果设定为immediate===true，因为开始已经调用过了此处无需调用
          if (!immediate) {
            result = func.apply(context, args);
            if (!timeout) context = args = null;
          }
        }
      };
      return function (...args) {
        context = this;
        timestamp = +new Date();
        const callNow = immediate && !timeout;
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
          result = func.apply(context, args);
          context = args = null;
        }

        return result;
      };
    },

    // 获取页面头部菜单栏的数据
    getHeadMenu() {
      let success = (res) => {
        // 2022/8/9 跳转路径为数组第一个
        // this.headMenuData[0].url = "/home"
        // console.log('headMenuData', this.headMenuData)
        // 由于后台返回的模块地址，和现在前台的模块路径不一样，所以修改一下
        let dataArr = res.data;
        // dataArr.forEach((item,index) => {
        // 	if(item.name == '课程专辑'){
        // 		let album =  dataArr[index]
        // 		dataArr.splice(dataArr.length-1)
        // 		dataArr.splice(3, 0, album)
        // 	}
        // });
        // this.changeUrl(dataArr, "1", "/home");
        // this.changeUrl(dataArr, "2", "/home/resource", "/home/resource", "/home/resourceList");
        // // this.changeUrl(dataArr, "6", "/home/course", "/home/course", "/home/liveList", "/home/openclassList");
        // this.changeUrl(dataArr, "6", "/home/albumList", "/home/albumDetail", "/home/albumPaper");
        // this.changeUrl(dataArr, "10", "/home/app");
        this.activeArr = dataArr.map((item) => item.url);
        if (res.data[0].url == "/") {
          res.data[0].url = "/homeindex";
        }
        this.headMenuData = res.data;
        this.jumpPage = res.data[0].url;
        // // console.log(JSON.parse(JSON.stringify(dataArr)),'dataArr',this.activeArr)
        // this.changeRoute();
      };
      this.$ajax.get("api/system/get_home_menu_cansee", {
        params: {},
        func: {
          success: success,
        },
      });
    },
    /***
     * 修改菜单栏跳转地址
     * arr菜单数据
     * 父级菜单id和地址 pid pUrl
     * 子级菜单地址 cUrl1 cUrl2 cUrl3
     *
     */
    changeUrl(arr, pid, pUrl, cUrl1, cUrl2, cUrl3) {
      // console.log(arr, pid, pUrl, cUrl1, cUrl2, cUrl3, 666)
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].is_default == 1 && arr[i].id == pid) {
          arr[i].url = pUrl;
          if (!is_empty(arr[i].children)) {
            if (arr[i].children[0] != undefined) {
              arr[i].children[0].url = cUrl1;
            }
            if (arr[i].children[1] != undefined) {
              arr[i].children[1].url = cUrl2;
            }
            if (arr[i].children[2] != undefined) {
              arr[i].children[2].url = cUrl3;
            }
          }
        } else if (arr[i].id == pid) {
          arr[i].url = pUrl;
        }
      }
    },
    // 菜单栏点击事件
    selectMenuTab(inx, keyPath) {
      console.log("here,sir", inx);
      this.activeInx = inx + "";
      sessionStorage.setItem("activeInx", inx + "");
      // // 点击菜单选项时，若搜索栏有搜索内容，则清掉
      if (this.keyWord != "") {
        this.selectVal = "1";
        this.keyWord = "";
        sessionStorage.setItem("selectVal", "1");
      }
    },

    // 点击logo事件
    pageHome() {
      // console.log('点击logo',sessionStorage.getItem("host_addr"))
      this.$router.push(this.jumpPage);
      this.activeInx = "0";
      // console.log('点击logo',this.jumpPage)
    },
    //获取logo
    getLogo() {
      let success = (res) => {
        this.logo_url = res.data[0].f_logo;
      };
      this.$ajax({
        url: "api/system/get_logo",
        method: "get",
        params: {},
        func: {
          success: success,
        },
      });
    },

    // hover用户头像弹窗里面的跳转
    goToMedule(module) {
      switch (module) {
        // 跳去管理中心
        case 1:
          window.location.href = this.pathOption.manage;
          break;
        // 跳去个人中心的我的消息
        case 2:
          window.location.href =
            this.pathOption.personal + "&routerUrl=message";
          break;
        // 跳去个人中心
        case 3:
          window.location.href = this.pathOption.personal;
          break;
        // 跳去个人个人档案（针对学生身份）
        case 4:
          this.checkUrl("schoolroll");
          break;
      }
    },
    // 检验是否有跳转到前台某个模块的权限
    checkUrl(url) {
      let success = (res) => {
        this.$router.push("/" + url);
      };
      this.$ajax.get("/api/login/checkthisnode", {
        params: {
          url: url,
          token: localStorage.getItem("token"),
          checkschoolappcode: this.CheckSchoolAppCode,
        },
        func: {
          success: success,
        },
      });
    },
    // 退出登录
    loginOut() {
      let success = (res) => {
        if (this.casFlag == false) {
          sessionStorage.clear();
          localStorage.clear();
          // window.location.href = this.loginOutHost + '/user-login';

          // 场景获取放在读取页面，所以如下改动
          window.location.href = this.loginOutHost;
        } else {
          sessionStorage.clear();
          localStorage.clear();
          // window.location.href = this.login_out + '/user-login';

          // 场景获取放在读取页面，所以如下改动
          window.location.href = this.login_out;
        }
      };
      this.$ajax({
        url: "api/login/login",
        method: "delete",
        params: {},
        func: {
          success: success,
        },
      });
    },
    // 搜索按钮点击事件：（页头搜索框+跳转）
    searchContent() {
      // 当点击的时候，把选中跳转模块的值缓存
      sessionStorage.setItem("selectVal", this.selectVal);
      // 根据选中值跳转
      switch (this.selectVal) {
        case "1":
          this.$router.push({
            path: "/home/resourceList",
            query: {
              keyword: this.keyWord,
            },
          });
          break;
        case "2":
          this.$router.push({
            path: "/home/albumList",
            query: {
              keyword: this.keyWord,
            },
          });
          break;
        case "3":
          this.$router.push({
            path: "/home/liveList",
            query: {
              keyword: this.keyWord,
            },
          });
          break;
        case "4":
          this.$router.push({
            path: "/home/openclassList",
            query: {
              keyword: this.keyWord,
            },
          });
          break;
      }
    },
    //查询登录情况
    checkLogin() {
      // console.log(this.pathOption, '链接111')
      let success = (data) => {
        this.loginData = data.data;
        sessionStorage.setItem(
          "user_info_str",
          JSON.stringify(deep_clone(data.data.userinfo))
        );
        this.$store.commit("SET_USERINFO", data.data.userinfo);
        // this.userInfo = data.data.userinfo; //用户信息

        this.userId = data.data.userinfo.id;
        this.checkRole = data.data.userinfo.check_role; //当前登录状态是什么身份
        this.role = data.data.userinfo.role; //身份id数组
        this.isTeacher = data.data.userinfo.thisLoginUserIsTeacher; //判断是不是老师
        this.teacherAuthority = data.data.userinfo.thisLoginUserIsTeachertrue; //教师权限
        this.login_out = data.data.logout_url;
        //后台权限
        if (
          typeof data.data.manage != "undefined" &&
          data.data.manage != null &&
          data.data.manage != ""
        ) {
          this.managerole = true;
        } else {
          this.managerole = false;
        }
        // 个人中心权限、我的消息显示
        if (typeof data.data.personal != "undefined") {
          this.personalFlag = true;
          var has_message = 0;
          for (let i = 0; i < data.data.node_personal.length; i++) {
            if (data.data.node_personal[i].name == "message") {
              has_message = 1;
            }
          }
          if (has_message == 1) {
            this.messageFlag = true;
          } else {
            this.messageFlag = false;
          }
        } else {
          this.messageFlag = false;
        }
        //是否是游客
        this.isVistor = data.data.userinfo.is_youke;
        // if (data.data.userinfo.is_youke == 1) {
        //   this.managerole = false;
        //   this.personalFlag = false;
        // }
        this.globalMessage(); //WebSocket获取全局信息提示
      };
      let fail = (data) => {
        this.userId = 0;
        this.$router.push({path: '/user-login'})
      };
      this.$ajax({
        url: "api/login/login",
        method: "get",
        params: {},
        func: {
          success: success,
          fail: fail,
        },
      });
    },

    //切换身份弹窗的确定按钮
    changeRole() {
      let success = (data) => {
        this.checkLogin();
        this.dialogVisible = false;
        this.$message.success(data.msg);
      };
      this.$ajax({
        url: "/api/login/check_login_section",
        method: "put",
        data: {
          check_role: this.checkRole,
        },
        func: {
          success: success,
        },
      });
    },
    // 我的消息未读数量
    messageUnread() {
      //是否登录
      if (this.userInfo.id == 0) {
        return false;
      }
      let success = (res) => {
        let count = 0;
        for (let i = 0; i < res.data.length; i++) {
          count += parseInt(res.data[i].num);
        }
        this.messageCount = count;
      };
      this.$ajax({
        url: "api/message/message_unread_count",
        method: "get",
        params: {},
        func: {
          success: success,
        },
      });
    },
    //全局消息
    globalMessage() {
      //是否登录
      if (this.userInfo.id == 0) {
        return;
      }
      let webSocketURL;
      //登录连接后台socket接收消息
      if (Number(this.isTencentCloud)) {
        webSocketURL = "wss:" + this.BASE_URL.split(":")[1] + ":7575";
      } else {
        webSocketURL = "ws:" + this.BASE_URL.split(":")[1] + ":7575";
      }
      var wss = new WebSocket(webSocketURL);
      wss.onopen = () => {
        var message = JSON.stringify({
          type: "login",
          user_id: this.userInfo.id,
        });
        wss.send(message);
        // console.log("已连接上...,发送身份信息：" + message);
      };
      wss.onmessage = (evt) => {
        var data = JSON.parse(evt.data);
        let that = this;
        that.$notify({
          title: "【" + data.content_type + "】",
          message: data.title,
          duration: 3000,
          offset: 130,
          //全局信息点击事件
          onClick: function () {
            that.globalMessageType = data.global_message_type;
            if (
              data.global_message_type == "notice" ||
              data.global_message_type == "comment"
            ) {
              that.globalNoticeMessageCheckLook(
                data.id,
                data.type,
                data.template,
                data.content_id,
                data.module
              );
            }
          },
        });
        this.messageUnread();
        // console.log("数据已接收...:", data);
      };
      wss.onclose = function () {
        // 关闭 websocket
        // console.log("连接已关闭...");
      };
    },
    /**全局消息通知查看转发
     * @param id 自增id
     * @param type 消息内容类型（1：消息；2：班级通知；3：动态；4：收到的评论；5：发起的評論）
     * @param template 模板对应index  0:不使用模板
     * @param contentId 内容id
     * @param moduleVal 所属模块
     */
    globalNoticeMessageCheckLook(id, type, template, contentId, moduleVal) {
      // console.log(id, type, template, contentId, moduleVal)
      if (parseInt(type) == 1) {
        this.noticeCheckLook(template, contentId, moduleVal);
      } else if (parseInt(type) === 2) {
        this.followCheckLook(template, contentId, moduleVal);
      } else if (parseInt(type) === 3) {
        this.groupCheckLook(template, contentId, moduleVal);
      } else if (parseInt(type) === 4) {
        this.globalCommentMessageCheckLook(contentId, moduleVal);
      }
    },
    // 跳个人中心相关的模块
    linkToPresonalModule(moduleUrl) {
      let urlString = this.pathOption.personal + "&routerUrl=" + moduleUrl;
      window.open(urlString, "_blank");
    },
    //全局消息通知跳转
    noticeCheckLook(template, contentId, moduleVal) {
      // console.log(template, contentId, moduleVal)
      //班级通知->个人中心班级通知
      if (template === "0" && moduleVal == "class") {
        this.linkToPresonalModule("notice");
      }
      //请假->个人中心请假
      else if (moduleVal == "leave") {
        this.linkToPresonalModule("leave");
      }
      //班级任务->个人中心班级任务
      else if (moduleVal == "task") {
        this.linkToPresonalModule("homework");
      }
      //直播
      else if (moduleVal == "live") {
        let success = (res) => {
          if (data.data.role_id.indexOf(1) > -1) {
            this.linkToPresonalModule("/teach/live/listlive");
          } else {
            this.$router.push({
              path: "/home/liveRoom",
              query: {
                id: contentId,
              },
            });
          }
        };
        this.$ajax({
          url: "/api/user/user_info",
          method: "get",
          params: {
            id: this.userInfo.id,
            level: 2,
          },
          func: {
            success: success,
          },
        });
      }
      //问答
      else if (moduleVal == "question") {
        if (template === "question_1") {
          this.linkToPresonalModule("/teach/ask/index");
        } else if (template === "question_2") {
          this.$router.push({
            path: "/home/openclassDetail",
            query: {
              id: contentId,
            },
          });
        }
      }
      //备课
      else if (moduleVal == "prepare") {
        this.$router.push({
          path: "/prepare/edit",
          query: {
            id: contentId,
          },
        });
      }
      //跳去邮件
      else if (moduleVal == "email") {
        this.$router.push({
          path: "/email/inbox#id=" + contentId,
        });
      }
    },
    //全局消息关注跳转
    followCheckLook(template, contentId, moduleVal) {
      if (moduleVal == "resource") {
        this.$router.push({
          path: "/home/resourceDetail",
          query: {
            id: contentId,
          },
        });
      } else if (moduleVal == "live") {
        this.$router.push({
          path: "/home/liveRoom",
          query: {
            id: contentId,
          },
        });
      } else if (moduleVal == "video") {
        this.$router.push({
          path: "/home/openclassDetail",
          query: {
            id: contentId,
          },
        });
      }
    },
    //全局消息圈组跳转
    groupCheckLook(template, contentId, moduleVal) {
      if (
        template == "group_0" ||
        template == "group_1" ||
        template == "group_3"
      ) {
        this.$router.push({
          path: "/group/introduct",
          query: {
            id: contentId,
          },
        });
      } else if (template == "group_4" || template == "group_2") {
        this.$router.push("/group/manage/selfCreated");
      }
    },
    //全局消息评论跳转
    globalCommentMessageCheckLook(contentId, moduleVal) {
      // console.info(contentId, moduleVal)
      //公开课评论跳转
      if (parseInt(moduleVal) === 0) {
        this.$router.push({
          path: "/home/openclassDetail",
          query: {
            id: contentId,
          },
        });
      }
      // //资源评论跳转
      else if (parseInt(moduleVal) === 1) {
        this.$router.push({
          path: "/home/resourceDetail",
          query: {
            id: contentId,
          },
        });
      }
    },
    // 设置语言
    setLang(lang) {
      let success = (res) => {
        this.$i18n.locale = lang;
        this.$message.success(res.msg);
      };
      this.$ajax.get("api/login/change_lang", {
        params: {
          default_lang: lang,
        },
        func: { success: success },
      });
    },
    goHref(url) {
      window.location = url;
    },
  },
};
</script>

<style lang="scss">
.i_text {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.personalfile-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url("../../../assets/images/archives-icon.png") no-repeat;
}

.el-notification.right {
  width: 300px;
  height: 64px;
  cursor: pointer;

  .el-notification__title {
    font-size: 14px;
    color: #d49b07;
  }

  .el-notification__group {
    margin-left: 0;
  }

  .el-notification__content p {
    width: 255px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .el-notification__closeBtn {
    top: 8px;
    right: 8px;
    padding: 2px;
    color: #fff;
    background-color: #0749aa;
    border-radius: 50%;
  }
}

.home-head {
  width: 100%;
  background: #E62126;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);

  #searchBar {
    background: #e9ecf3;
  }

  .el-popover {
    top: 75px;
  }
}

.header-cont {
  height: 48px;
  line-height: 48px;
  padding: 26px 0 26px;

  .logo {
    height: 50px;
    overflow: hidden;

    img {
      max-width: 100%;
      object-fit: cover;
    }
  }

  .logo:hover {
    cursor: pointer;
  }

  .head-search {
    position: relative;
    width: 320px;

    .el-select {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 50;

      .el-input {
        width: 84px;
      }

      .el-input__inner {
        padding: 0 20px 0 8px;
        border: 1px solid transparent;
        background: transparent;
        color: #000;
        text-align: center;
      }

      .el-input__suffix
        .el-input__suffix-inner
        .el-select__caret.el-input__icon.el-icon-arrow-up {
        color: #231815;
      }

      .el-input__icon {
        width: 14px;
      }

      .el-icon-arrow-up:before {
        // content: "\E78F";
      }
    }

    .input-with-select.el-input.el-input-group.el-input-group--append.el-input--suffix
      .el-input-group__append {
      background-color: #E62126;
      border: 1px solid #E62126;
    }

    .gery-line {
      display: block;
      height: 16px;
      position: absolute;
      top: 15px;
      left: 84px;
      z-index: 50;
      border-left: 1px solid #e0e0e0;
    }

    .input-with-select {
      .el-input__inner {
        padding: 0 25px 0 90px;
        height: 48px;
      }

      .el-input-group__append {
        padding: 0 10px;
        color: #fff;
        background-color: #338efc;
        border: 1px solid #338efc;

        .search-icon {
          background-position: -26px -812px;
          width: 16px;
          height: 17px;
          background-image: url("../../../../public/images/ipng.png");
          background-repeat: no-repeat;
          display: inline-block;
          vertical-align: top;
        }
      }
    }
  }

  .login-info {
    .header-btns {
      > img {
        margin-right: 10px;
        width: 50px;
        height: 50px;
      }

      > button {
        color: #E62126;
      }
    }
  }

  .header-btns {
    display: inline-block;
    margin-left: 40px;

    .cut {
      padding: 0 5px;
    }
  }
}

.isfixed {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
  z-index: 999;

  .header-cont {
    padding: 10px 0;
  }
}

.el-select-dropdown {
  .el-select-dropdown__item {
    padding: 0 14px;
  }

  .el-select-dropdown__item.hover {
    color: #fff;
    background-color: #338efc;
  }
}

.user-info {
  display: inline-block;
  margin-left: 40px;

  .user-info-a {
    display: inline-block;
  }

  .avatar-img {
    display: inline-block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    vertical-align: middle;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .avatar-text {
    display: inline-block;
    width: 68px;
    height: 48px;
    margin-left: 10px;
    position: relative;
    vertical-align: middle;

    .userName {
      top: -10px;
    }

    .roleName {
      top: 8px;
      color: #999;
    }

    .userName,
    .roleName {
      position: absolute;
      left: 0;
      width: 68px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}

.userinfoH {
  .safe-exit {
    font-size: 14px;
    // color: #888888;
    cursor: pointer;
    margin: 5px 20px 5px;
    display: inline-block;
  }

  .safe-exit:hover {
    color: #ffacac;
  }
}

.i_nav.maxW > ul {
  padding: 0;
  height: auto;
  background: #E62126;

  > li {
    height: 48px;
    // line-height: 48px;
    font-size: 18px;
    color: #fff;

    &.is-active {
      font-weight: bold;
      background: #0057a7;
      border-radius: unset;
    }
  }

  .el-menu-item:focus,
  .el-menu-item:hover {
    color: #fff;
    background: #0057a7;
  }
}

.userinfoH_1 {
  width: 220px;
  padding: 12px 20px 0;
  font-size: 12px;
  overflow: hidden;
}

.userinfoH_1 > a {
  box-sizing: border-box;
  display: inline-block;
  width: 100px;
  height: 36px;
  padding: 0 5px;
  margin-bottom: 13px;
  vertical-align: top;
  text-align-last: initial;
  line-height: 36px;
  color: #333;
  background-color: #efefef;
  border-radius: 3px;
  text-align: center;
  @extend .i_text;
}

.userinfoH_1 > a:nth-child(2n) {
  margin-left: 20px;
}

.userinfoH_1 > a > i {
  margin-right: 5px;
  vertical-align: middle;
}

.userinfoH_1 > a:hover {
  color: #2f6d8c;
  background: #d8effc;
}

.messagerole .el-badge {
  .el-badge__content.isfixed {
    right: 12px;
  }

  i {
    vertical-align: middle;
  }

  i:nth-child(1) {
    margin-right: 5px;
  }
}

.personalrole {
  display: block;
  background: #efefef;
  border-radius: 3px;
  height: 36px;
  line-height: 36px;
  text-indent: 15px;
  margin: 0 20px 10px 20px;
}

.personalrole > i {
  margin-right: 60px;
  vertical-align: middle;
}

.personalrole:hover {
  color: #2f6d8c;
  background: #d8effc;
}

.head-menu {
  padding-bottom: 10px;
  border-bottom: none !important;

  .el-menu-item {
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-bottom: none;
    border-radius: 10px;
    font-size: 16px;
    padding: 0;
    margin-right: 40px;
    color: #000;
    position: relative;

    &:hover {
      .menu-hover-box {
        display: block;
        background: #E62126;
      }
    }

    a {
      display: block;
      padding: 0 14px;
      height: 48px;
      line-height: 48px;
      border-radius: 10px;
    }
  }

  .el-menu-item.is-active {
    -moz-border-radius: 10px;
    border-radius: 10px;
    color: #fff;
    background: #0057a7;
    border-bottom: none;
  }

  .el-menu-item.is-active:hover {
    color: #fff;
    background: #0057a7;
  }
}

.menu-hover-box {
  display: none;
  position: absolute;
  width: 1200px;
  left: 0;
  bottom: -50px;
  z-index: 22;
  height: 50px;
  line-height: 50px;
  background-color: #fff;
  -webkit-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);

  ul {
    padding: 0 30px;
  }

  li {
    float: left;
    color: #000;
    color: #fff;

    &:hover {
      font-size: 14px;
      background: #E62126;
    }

    a {
      margin-right: 40px;
      font-size: 14px;
    }
  }
}

.identity-dialog {
  .role-ul {
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;

    li {
      display: inline-block;
      margin: 15px 6px;
      cursor: pointer;
      width: 80px;

      span {
        display: inline-block;
        width: 100%;
        text-align: center;
      }

      .rolename {
        margin-top: 15px;
      }
    }

    .role-icon {
      position: relative;

      .Select01 {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .foot-btns {
    text-align: center;
    margin: 20px 0;
  }
}

.el-popover {
  font-size: 12px;
}

.lang-set {
  display: none;
  // position: absolute;
  position: fixed;
  top: 30px;
  right: 30px;
  z-index: 3;
}
</style>
